import { makeStyles } from '@material-ui/core/styles';
import { GRADIENT } from 'UI/constants/styles';

import { FAB_SIZE } from './FloatingButton.constants';

export const useStyles = makeStyles(theme => ({
  root: {
    position: 'fixed',
    zIndex: theme.zIndex.aiAssistant,
    touchAction: 'none',
    willChange: 'left, top',
    cursor: 'ns-resize'
  },
  rootSnapping: {
    transition:
      'left 220ms cubic-bezier(0.2, 0.9, 0.2, 1), top 220ms cubic-bezier(0.2, 0.9, 0.2, 1)'
  },
  fab: {
    width: FAB_SIZE,
    height: FAB_SIZE,
    borderRadius: theme.spacing(1, 0, 0, 1),
    color: theme.palette.common.white,
    background: GRADIENT,
    boxShadow: '0 12px 28px rgba(103, 58, 183, 0.35)'
  }
}));
